import { Box, Flex, LinkBox, LinkOverlay, Text } from '@chakra-ui/react'
import { NormalButton } from '@!/components/Button/NormalButton'
import { CoverImage } from '@!/Store/Common/components'

const CartItem = ({ books, handleRemoveCartItems }) => {
  return (
    <>
      {books.map((book, index) => (
        <LinkBox key={index}>
          <Flex alignItems="center" borderTop={index !== 0 ? '1px solid #e0e0e0' : 'none'} padding="16px 0" justify="space-between">
            <LinkOverlay href={`/store/books/${book.content_id}`}>
              <Box display="flex">
                <CoverImage src={book.image_url} alt={book.content_name} width="55px" objectFit="cover" />
                <Box ml={2} fontWeight="bold">
                  <Text fontSize="xs" paddingBottom="4px">
                    {book.content_name}
                  </Text>
                  <Flex align="baseline">
                    <Text fontSize="md" color="#e94841">
                      {book.price}
                    </Text>
                    <Text fontSize="3xs">&nbsp;円{book.price !== 0 && '（税込）'}</Text>
                  </Flex>
                </Box>
              </Box>
            </LinkOverlay>
            <NormalButton width="46px" height="29px" fontSize="3xs" borderRadius="2px" onClick={() => handleRemoveCartItems([book.content_id])}>
              削除
            </NormalButton>
          </Flex>
        </LinkBox>
      ))}
    </>
  )
}

export default CartItem
